import { ChangeEvent, ElementRef, FC, useEffect, useRef, useState } from 'react';
import { AddressSuggestions } from 'react-dadata';
import type { DaDataAddress, DaDataSuggestion } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import './react-address-dadata.scss';
import { useDispatch } from 'react-redux';
import { setInfoOrderDetail } from 'redux/ordersDetails/slice';

export const AddressDadata: FC = () => {
  const [value, setValue] = useState<DaDataSuggestion<DaDataAddress> | null>(null);
  const [defaultValue, setDefaultValue] = useState<string | undefined>(undefined);
  const suggestionsRef = useRef<ElementRef<typeof AddressSuggestions>>(null);
  const dispatch = useDispatch();

  const handleChange = (suggestion?: DaDataSuggestion<DaDataAddress>) => {
    setValue(suggestion ?? null);
  };

  useEffect(() => {
    const suggestionData = value?.data;
    if (suggestionData) {
      suggestionData.flat !== null
        ? dispatch(setInfoOrderDetail({ key: 'apartment', value: suggestionData.flat }))
        : dispatch(setInfoOrderDetail({ key: 'apartment', value: '' }));
      suggestionData.city !== null
        ? dispatch(setInfoOrderDetail({ key: 'city', value: suggestionData.city }))
        : dispatch(setInfoOrderDetail({ key: 'city', value: '' }));
      suggestionData.street_with_type !== null
        ? dispatch(
            setInfoOrderDetail({ key: 'street', value: suggestionData.street_with_type }),
          )
        : dispatch(setInfoOrderDetail({ key: 'street', value: '' }));
      suggestionData.house !== null
        ? dispatch(setInfoOrderDetail({ key: 'home', value: suggestionData.house }))
        : dispatch(setInfoOrderDetail({ key: 'home', value: '' }));
    }
    if (defaultValue === '' && suggestionsRef.current) {
      suggestionsRef.current.setInputValue('');
      setValue(null);
      dispatch(setInfoOrderDetail({ key: 'apartment', value: '' }));
      dispatch(setInfoOrderDetail({ key: 'city', value: '' }));
      dispatch(setInfoOrderDetail({ key: 'street', value: '' }));
      dispatch(setInfoOrderDetail({ key: 'home', value: '' }));
    }
  }, [value, defaultValue]);

  return (
    <div style={{ position: 'relative' }}>
      <AddressSuggestions
        ref={suggestionsRef}
        token={`${process.env.REACT_APP_API_KEY}`}
        value={value ?? undefined}
        onChange={handleChange}
        defaultQuery={''}
        selectOnBlur={true}
        count={5}
        highlightClassName='suggestion_highlight'
        currentSuggestionClassName='suggestion_select'
        inputProps={{
          placeholder: 'Начните вводить адрес',
          onChange: (e: ChangeEvent<HTMLInputElement>) => {
            if (e) setDefaultValue(e.target.value.trimStart());
          },
        }}
      />
      <span className='placeholder'>Адрес</span>
    </div>
  );
};
